export const HasPermission = (permission) => {
  if (permission?.appAccess === true) {
    return true;
  } else {
    return false;
  }
};

export const validateFileName = (file) => {
  const fileExt = "dxf";
  const fileName = file.split(".");
  const zipFile = fileName[0].concat(".zip").trim();
  return zipFile;
};

export const uuidv4 = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export const validateRulesInput = (data) => {
  let hasError = false;

  data.forEach((item) => {
    if (item.rules && Array.isArray(item.rules)) {
      item.rules.forEach((rule) => {
        let errors = [];

        if (!rule.ddName || rule.ddName.trim() === "") {
          errors.push("ddName is required, please select appropriate value.");
        }
        if (!rule.min || rule.min.trim() === "") {
          errors.push("min is required, please select appropriate value.");
        }
        if (!rule.max || rule.max.trim() === "") {
          errors.push("max is required, please select appropriate value.");
        }

        if (errors.length > 0) {
          hasError = true;
          rule.error = errors; // add error field
        }
      });
    }
  });

  return {
    isError: hasError,
    data: data,
  };
};

export const validateDrawingRules = (data) => {
  let hasError = false;

  data.forEach((rule) => {
    let errors = [];

    if (errors.length > 0) {
      hasError = true;
      rule.error = errors;
    }

    // Validate nested drawingDependencies
    if (rule.drawingDependencies && Array.isArray(rule.drawingDependencies)) {
      rule.drawingDependencies.forEach((dep) => {
        let depErrors = [];

        if (!dep.ddName || dep.ddName.trim() === "") {
          depErrors.push(
            "ddName is required, please select appropriate value."
          );
        }
        if (!dep.minValue || dep.minValue.trim() === "") {
          depErrors.push(
            "minValue is required, please select appropriate value."
          );
        }
        if (!dep.maxValue || dep.maxValue.trim() === "") {
          depErrors.push(
            "maxValue is required, please select appropriate value."
          );
        }

        if (depErrors.length > 0) {
          hasError = true;
          dep.error = depErrors;
        }
      });
    }
  });

  return {
    isError: hasError,
    data: data,
  };
};


export const validateLayersRules = (data) => {
    let hasError = false;

    data.forEach(layer => {
        if (layer.layerRules && Array.isArray(layer.layerRules)) {
            layer.layerRules.forEach(rule => {
                if (rule.layerDependencies && Array.isArray(rule.layerDependencies)) {
                    rule.layerDependencies.forEach(dep => {
                        let depErrors = [];

                        if (!dep.ddName || dep.ddName.trim() === "") {
                            depErrors.push("ddName is required, please select appropriate value.");
                        }
                        if (!dep.minValue || dep.minValue.trim() === "") {
                            depErrors.push("minValue is required, please select appropriate value.");
                        }
                        if (!dep.maxValue || dep.maxValue.trim() === "") {
                            depErrors.push("maxValue is required, please select appropriate value.");
                        }

                        if (depErrors.length > 0) {
                            hasError = true;
                            dep.error = depErrors;
                        }
                    });
                }
            });
        }
    });

    return {
        isError: hasError,
        data: data
    };
}